module.exports = __webpack_public_path__ + "img/a-3Cshumajiadian.8db30e7b.png";